export default "__VITE_PUBLIC_ASSET__83c6db8e__"